import { writable, get } from "svelte/store"

const initLoc = {
    path: (typeof window !== "undefined" && window.location?.pathname) || "/",
    search: (typeof window !== "undefined" && window.location?.search) || "",
    push: false,
    pop: false,
    categoryPath: "",
}
initLoc.categoryPath = initLoc.path.replace(/\/\d{4,99}[^\/]+$/, "")

export const location = writable(initLoc)
